import Vue from 'vue';

export const jumpToContent = { // eslint-disable-line
  bind: (el) => {
    Vue.nextTick(() => {
      const tabKey = 9;
      const headerNavbar = document.getElementsByClassName('nav-bar')[0];
      const jumpLink = el.getElementsByTagName('a')[0];

      let wasShown = false;

      document.addEventListener('keydown', (e) => {
        if (e.keyCode === tabKey && !wasShown) {
          headerNavbar.classList.add('show-link');
          headerNavbar.focus();
          wasShown = true;
          e.preventDefault();
        }
      });

      jumpLink.addEventListener('click', () => {
        headerNavbar.classList.remove('show-link');
      });
    });
  },
};
